import { bytesToBase64, base64ToBytes } from "../utils/bytes";
import { deriveAesGcmKey } from "../utils/kdf";

export async function encryptForStorage(plainText, passphrase) {
  const enc = new TextEncoder();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const iterations = 200_000;

  const key = await deriveAesGcmKey(passphrase, salt, iterations);

  const ctBuf = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    enc.encode(plainText)
  );
  const ct = new Uint8Array(ctBuf);

  return {
    v: 1,
    alg: "AES-GCM",
    kdf: "PBKDF2",
    iter: iterations,
    salt: bytesToBase64(salt),
    iv: bytesToBase64(iv),
    ct: bytesToBase64(ct),
  };
}

// decrypt using passphrase
export async function decryptFromStorage(record, passphrase) {
  const dec = new TextDecoder();
  const salt = base64ToBytes(record.salt);
  const iv = base64ToBytes(record.iv);
  const ct = base64ToBytes(record.ct);

  const key = await deriveAesGcmKey(passphrase, salt, record.iter || 200_000);

  try {
    const ptBuf = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      ct
    );
    return dec.decode(ptBuf);
  } catch (e) {
    //  passphrase incorrect 
    throw new Error("Decryption failed");
  }
}
